import React from "react";
import { Component, Fragment } from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import ReactPDF from '@react-pdf/renderer';
import { pdf, Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from '@david.kucsai/react-pdf-table';
import {
    hashRandom,
    hashString,
    hashObject,
    hashArray
  } from 'react-hash-string'

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label,
  Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown
} from 'reactstrap';

import { Line, Bar } from 'react-chartjs-2';
import Chart from 'react-c3-component';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';
import { appendProductFilter, getStoredProductType } from '../../dashboard/product-filter';
import logoEvo from '../../../assets/images/logo2_x3_text.png';
import logoEvo2 from '../../../assets/images/logo2_x3_text_clear.png';
import warrantyPDF from '../../../assets/pdf/warranty/warranty.pdf';
var moment = require('moment-timezone');

// Create styles
const styles = StyleSheet.create({
  page: { backgroundColor: '#ffffff' },
  section: { color: 'white', textAlign: 'center', margin: 30 },
  title: {
    fontSize: 20,
    marginVertical: 5,
    textAlign: 'center',
    color: '#f3c12b'
  },
  TableCellHeaderStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 14,
    fontWeight: 900,
    backgroundColor: '#000000',
    color: '#f3c12b'
  },
  TableCellBodyStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 11,
    backgroundColor: '#ffffff'
  },
  TableStyle : {
    padding: 5,
  },
  Table: {
    marginVertical: 5,
    marginHorizontal: 5,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
});

// Create Document Component
// const MyDocument = (data) => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <Text style={styles.section} fixed>
//         ~ Created with Azena Medical Gemini EVO Dashboard ~
//       </Text>
//       <Text style={styles.title}>Procedures Report</Text>
//       <Table data={this.props.data}>
//         <TableHeader>
//             <TableCell>
//                 First Name
//             </TableCell>
//             <TableCell>
//                 Last Name
//             </TableCell>
//             <TableCell>
//                 DOB
//             </TableCell>
//             <TableCell>
//                 Country
//             </TableCell>
//             <TableCell>
//                 Phone Number
//             </TableCell>
//         </TableHeader>
//         <TableBody>
//             <DataTableCell getContent={(r) => r.serialNumber}/>
//             <DataTableCell getContent={(r) => r.date}/>
//             <DataTableCell getContent={(r) => r.procedureType}/>
//             <DataTableCell getContent={(r) => r.wavelength}/>
//             <DataTableCell getContent={(r) => r.length}/>
//         </TableBody>
//       </Table>
//     </Page>
//   </Document>
// );


class MyDocument extends React.Component {

  async componentDidMount() {

    console.log("MyDocument procedure data: " + JSON.stringify(this.props.data));
	}

  render() {
         return (
           <Document>
             <Page size="A4" style={styles.page}>
               <Image style={styles.image} src={logoEvo2} />
               <Text style={styles.title}></Text>
               <Text style={styles.title}>Procedures Report</Text>
               <Text style={styles.title}></Text>
               <Table style={styles.Table} data={this.props.data}>
                 <TableHeader style={styles.Table} textAlign={"center"}>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Date
                     </TableCell>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Procedure
                     </TableCell>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Power
                     </TableCell>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Wavelength
                     </TableCell>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Treatments
                     </TableCell>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Dosage
                     </TableCell>
                     <TableCell style={styles.TableCellHeaderStyle}>
                         Length
                     </TableCell>
										 <TableCell style={styles.TableCellHeaderStyle}>
                         Serial
                     </TableCell>
										 <TableCell style={styles.TableCellHeaderStyle}>
                         Time
                     </TableCell>
                 </TableHeader>
                 <TableBody textAlign={"center"} >
								 		<DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.date}/>
                    <DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.procedureType}/>
                    <DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.power}/>
                    <DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.wavelength}/>
                    <DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.treatments}/>
                    <DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.dosage}/>
                    <DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.length}/>
										<DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.serialNumber}/>
										<DataTableCell style={styles.TableCellBodyStyle} getContent={(p) => p.time}/>
                 </TableBody>
               </Table>
             </Page>
           </Document>
     )}
}

const ProceduresNoData = ({ loading, className, children, ...rest }) => {
	if (loading) {
		return null;
	}

	return (
		<div className={['rt-noData', className].filter(Boolean).join(' ')} {...rest}>
			{children}
		</div>
	);
};

const ProceduresLoading = ({ loading, loadingText, className, style, ...rest }) => (
	<div
		className={['-loading', loading ? '-active' : '', className].filter(Boolean).join(' ')}
		style={Object.assign({}, style, { backgroundColor: 'rgba(0, 0, 0, 0.55)' })}
		{...rest}
	>
		<div className="-loading-inner" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
			{loadingText}
		</div>
	</div>
);

const PROCEDURE_FILTER_DEBOUNCE_MS = 600;

const getActiveProcedureFilters = filters => (filters || []).reduce((activeFilters, filter) => {
	if (!filter || !filter.id || filter.value === undefined || filter.value === null || filter.value === '') {
		return activeFilters;
	}

	// Keep one current value per column while preserving filters from the other columns.
	const existingFilterIndex = activeFilters.findIndex(activeFilter => activeFilter.id === filter.id);
	if (existingFilterIndex === -1) {
		activeFilters.push({ id: filter.id, value: filter.value });
	} else {
		activeFilters[existingFilterIndex] = { id: filter.id, value: filter.value };
	}

	return activeFilters;
}, []);

class ProceduresPagination extends React.Component {

	constructor(props) {
		super(props);
		this.state = { page: props.page };
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ page: nextProps.page });
	}

	getSafePage = page => {
		if (Number.isNaN(page)) {
			page = this.props.page;
		}
		return Math.min(Math.max(page, 0), Math.max(this.props.pages - 1, 0));
	};

	changePage = page => {
		if (this.props.loading) {
			return;
		}

		page = this.getSafePage(page);
		this.setState({ page });
		if (this.props.page !== page) {
			this.props.onPageChange(page);
		}
	};

	applyPage = event => {
		if (event) {
			event.preventDefault();
		}
		if (this.props.loading) {
			return;
		}

		const page = this.state.page;
		this.changePage(page === '' ? this.props.page : page);
	};

	render() {
		const {
			pages,
			page,
			showPageSizeOptions,
			pageSizeOptions,
			pageSize,
			showPageJump,
			canPrevious,
			canNext,
			onPageSizeChange,
			loading
		} = this.props;
		const paginationDisabled = loading;

		return (
			<div className={(this.props.className || '') + ' -pagination'} style={this.props.style}>
				<div className="-previous">
					<button
						type="button"
						className="-btn"
						onClick={() => this.changePage(page - 1)}
						disabled={paginationDisabled || !canPrevious}
					>
						{this.props.previousText}
					</button>
				</div>
				<div className="-center">
					<span className="-pageInfo">
						{this.props.pageText}{' '}
						{showPageJump ? (
							<div className="-pageJump">
								<input
									type={this.state.page === '' ? 'text' : 'number'}
									disabled={paginationDisabled}
									onChange={event => {
										const value = event.target.value;
										if (value === '') {
											this.setState({ page: value });
											return;
										}
										this.setState({ page: this.getSafePage(value - 1) });
									}}
									value={this.state.page === '' ? '' : this.state.page + 1}
									onBlur={this.applyPage}
									onKeyPress={event => {
										if (event.which === 13 || event.keyCode === 13) {
											this.applyPage(event);
										}
									}}
								/>
							</div>
						) : (
							<span className="-currentPage">{page + 1}</span>
						)}{' '}
						{this.props.ofText} <span className="-totalPages">{pages || 1}</span>
					</span>
					{loading && (
						<span
							className="procedure-pagination-loading"
							role="status"
							aria-live="polite"
							style={{ margin: '3px 10px', whiteSpace: 'nowrap' }}
						>
							<i className="fa fa-spinner fa-spin" aria-hidden="true" /> Loading...
						</span>
					)}
					{showPageSizeOptions && (
						<span className="select-wrap -pageSizeOptions">
							<select onChange={event => onPageSizeChange(Number(event.target.value))} value={pageSize}>
								{pageSizeOptions.map((option, index) => (
									<option key={index} value={option}>
										{option} {this.props.rowsText}
									</option>
								))}
							</select>
						</span>
					)}
				</div>
				<div className="-next">
					<button
						type="button"
						className="-btn"
						onClick={() => this.changePage(page + 1)}
						disabled={paginationDisabled || !canNext}
					>
						{this.props.nextText}
					</button>
				</div>
			</div>
		);
	}
}

class ProceduresList extends React.Component {

	constructor(props) {
    super(props);
    this.state = {
			rSelected: 3,
			totalProcedures: 0,
      dropdownOpen: false,
      currentDataSetting: 5,
      startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Last 30 Days",
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			productType: getStoredProductType(),
      procedures: [],
      procedureTypes: [],
      wavelengthTypes: ["UNKNOWN", "810", "980", "DUAL"],
      obj: {},
      objArray: [],
			code: 123456,
			verificationError: false,
			statusSubject: "Failed",
			statusMessage: "Failed to send message.",
      modal: false,
      modal2: false,
			modal3: false,
			modal4: false,
			selectAll: false,
			checked: [],
			selectdata: [],
			selectedProcedures: [],
			selectedProcedureRows: {},
			pages: -1,
			pageSize: 15,
			currentPage: 0,
			tableFiltered: [],
			tableSorted: [],
			loading: false,
			procedureErrorMessage: "",
			fileName: "",
			statusSubject: "Failed",
			statusMessage: "Failed to send message.",
	  };

		this.pdfdata = [];
		this.procedureRequestId = 0;
		this.procedureTypesRequestId = 0;
		this.filterTimeout = null;
		this.lastFilterSignature = JSON.stringify([]);

    this.toggleDropDown = this.toggleDropDown.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.toggle4 = this.toggle4.bind(this);
		this.handleChange = this.handleChange.bind(this);
    this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
		this.handleProductTypeChange = this.handleProductTypeChange.bind(this);

  }

	async componentDidMount() {

		document.body.addEventListener('set-product-type', this.handleProductTypeChange);
    this.getProcedureTypes();
		//let hash = hashRandom();
		//console.log("hash: " + JSON.stringify(hash));
	}

	componentWillUnmount() {
		this.procedureRequestId += 1;
		this.procedureTypesRequestId += 1;
		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
		}
		document.body.removeEventListener('set-product-type', this.handleProductTypeChange);
	}

	handleProductTypeChange(event) {
		const productType = event && event.detail ? event.detail.id : getStoredProductType();
		if (parseInt(productType) === parseInt(this.state.productType)) {
			return;
		}

		this.procedureRequestId += 1;
		this.procedureTypesRequestId += 1;
		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
			this.filterTimeout = null;
		}

		this.setState({
			productType,
			procedures: [],
			procedureTypes: [],
			selectdata: [],
			selectedProcedureRows: {},
			selectAll: false,
			loading: true,
			procedureErrorMessage: ""
		}, () => {
			this.getProcedureTypes();
			this.refreshTable(true);
		});
	}

	handleChange = () => {
		const selectedProcedureRows = Object.assign({}, this.state.selectedProcedureRows);
		const allPageRowsSelected = this.state.procedures.length > 0 && this.state.procedures.every((procedure, index) => {
			return selectedProcedureRows[this.getProcedureRowId(procedure, index)];
		});
		const selectAll = !allPageRowsSelected;

		this.state.procedures.forEach((procedure, index) => {
			const rowId = this.getProcedureRowId(procedure, index);
			if (selectAll) {
				selectedProcedureRows[rowId] = this.formatProcedure(procedure, index, true);
			} else {
				delete selectedProcedureRows[rowId];
			}
		});

		this.setState({ selectAll, selectedProcedureRows });
  };

  handleSingleCheckboxChange = index => {
		const procedure = this.state.procedures[index];
		if (!procedure) {
			return;
		}

		const rowId = this.getProcedureRowId(procedure, index);
		const selectedProcedureRows = Object.assign({}, this.state.selectedProcedureRows);
		if (selectedProcedureRows[rowId]) {
			delete selectedProcedureRows[rowId];
		} else {
			selectedProcedureRows[rowId] = this.formatProcedure(procedure, index, true);
		}

		const selectAll = this.state.procedures.length > 0 && this.state.procedures.every((pageProcedure, pageIndex) => {
			const pageRowId = this.getProcedureRowId(pageProcedure, pageIndex);
			return pageRowId === rowId ? !!selectedProcedureRows[rowId] : !!selectedProcedureRows[pageRowId];
		});

		this.setState({ selectAll, selectedProcedureRows });
  };

	getProcedureRowId = (procedure, index) => {
		if (procedure.rowId) {
			return procedure.rowId;
		}
		return [procedure.SerialNumber, procedure.wavelength, procedure.usage_rng, procedure.timestamp, index].join(':');
	};

	formatProcedure = (procedure, key, formatDate) => {
		var procedureLabel = procedure.procedureType || "Manual";
		var dosageLabel = procedure.dosageLabel || "";

		if (!procedure.procedureType) {
			if (procedure.power) {
				procedureLabel = "Manual";
			} else if (procedure.preset) {
				let procedureArray = this.state.procedureTypes.find(t => t.OBJID == procedure.preset);
				if (procedureArray) {
					procedureLabel = procedureArray.Name;
				} else {
					procedureLabel = "Unknown";
				}
			}
		}

		if (!procedure.dosageLabel) {
			if (procedureLabel == "25mm") {
				dosageLabel = Math.round((1 * procedure.totalseconds) / 4.91) + " J/cm2";
			} else if (procedureLabel == "7mm") {
				dosageLabel = Math.round((0.3 * procedure.totalseconds) / 0.38) + " J/cm2";
			} else if (procedureLabel == "3mm") {
				dosageLabel = Math.round((0.3 * procedure.totalseconds) / 0.07) + " J/cm2";
			}
		}

		var powerLabel = procedure.powerLabel || "0.0 Watts";
		if (!procedure.powerLabel) {
			if (procedure.watts) {
				powerLabel = (procedure.watts / 10).toFixed(1) + " Watts";
			} else if (procedure.power) {
				powerLabel = (procedure.power / 10).toFixed(1) + " Watts";
			}
		}

		var wavelengthType = procedure.wavelengthLabel !== undefined
			? procedure.wavelengthLabel
			: this.state.wavelengthTypes[procedure.wavelength];
		var lengthLabel = procedure.lengthLabel;
		if (lengthLabel === undefined) {
			var d = Number(procedure.totalseconds);
			var h = Math.floor(d / 3600);
			var m = Math.floor(d % 3600 / 60);
			var s = Math.floor(d % 3600 % 60);
			var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
			var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
			var sDisplay = s > 0 ? s + " sec" : "";
			lengthLabel = hDisplay + mDisplay + sDisplay;
		}

		return {
			id: this.getProcedureRowId(procedure, key),
			serialNumber: procedure.SerialNumber,
			date: formatDate ? Moment(procedure.timestamp).format("MMM Do YYYY") : procedure.timestamp,
			procedureType: procedureLabel,
			wavelength: wavelengthType,
			treatments: procedure.treatments,
			dosage: dosageLabel,
			power: powerLabel,
			length: lengthLabel,
			totalSeconds: procedure.totalseconds,
			time: procedure.timeLabel || Moment(procedure.timestamp).format("h:mm:ssa")
		};
	};

  toggle() {
	  this.setState({
	    modal: !this.state.modal
	  });
	}

	generateReport(data) {

		if (data.length<201) {
			this.uploadToS3(data);

		  this.setState({
		    modal: !this.state.modal
		  });
		} else {
			this.toggle4();
		}

	}

  toggle2() {

	  this.setState({
	    modal2: !this.state.modal2
	  });
	}

	toggle3() {
	  this.setState({
	    modal3: !this.state.modal3
	  });
	}

	toggle4() {
	  this.setState({
	    modal4: !this.state.modal4
	  });
	}

  toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	handleDateChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({startDate: event.target.value});
			this.setState({
	      currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({endDate: event.target.value});
			this.setState({
				currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		}
  }

	handleSubmit(event) {
		this.procedureRequestId += 1;
		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
			this.filterTimeout = null;
		}
		this.setState({
			procedures: [],
			selectdata: [],
			selectedProcedureRows: {},
			selectAll: false,
			loading: true,
			procedureErrorMessage: ""
		}, () => this.refreshTable(true));
  }

	selectDropDownItem(id, title) {

		this.procedureRequestId += 1;
		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
			this.filterTimeout = null;
		}
		var startDate = this.state.startDate;
		if (id==1) {
			startDate = Moment().startOf('day').format('YYYY-MM-DD');
		} else if (id==2) {
			startDate = Moment().startOf('week').format('YYYY-MM-DD');
		} else if (id==3) {
			startDate = Moment().startOf('month').format('YYYY-MM-DD');
		} else if (id==5) {
			startDate = Moment().subtract(1, 'month').format('YYYY-MM-DD');
		}

		this.setState({
			currentItem: title,
			currentDataSetting: id,
			startDate,
			endDate: Moment().format('YYYY-MM-DD'),
			procedures: [],
			selectdata: [],
			selectedProcedureRows: {},
			selectAll: false,
			loading: true,
			procedureErrorMessage: ""
		}, () => this.refreshTable(true));
  }

	refreshTable = (resetPage) => {
		if (this.table) {
			const tableState = this.table.getResolvedState();
			if (resetPage && tableState.page !== 0) {
				this.table.onPageChange(0);
				return;
			}
			this.getData(
				tableState.page,
				tableState.pageSize,
				getActiveProcedureFilters(tableState.filtered),
				tableState.sorted
			);
			return;
		}

		this.getData(0, this.state.pageSize, getActiveProcedureFilters(this.state.tableFiltered), this.state.tableSorted);
	};

	handleRefresh = () => {
		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
			this.filterTimeout = null;
		}
		this.refreshTable(false);
	};

	handleFetchData = (tableState) => {
		// Invalidate any request already in flight before a new table state is queued.
		this.procedureRequestId += 1;
		// React Table supplies every active column filter here. Snapshot the whole set so
		// the eventual debounced request combines them instead of using only the last edit.
		const filtered = getActiveProcedureFilters(tableState.filtered);
		const sorted = tableState.sorted || [];
		const filterSignature = JSON.stringify(filtered);
		const filtersChanged = filterSignature !== this.lastFilterSignature;
		this.lastFilterSignature = filterSignature;

		this.setState({
			currentPage: tableState.page,
			pageSize: tableState.pageSize,
			tableFiltered: filtered,
			tableSorted: sorted,
			loading: true,
			procedureErrorMessage: "",
			selectedProcedureRows: filtersChanged ? {} : this.state.selectedProcedureRows,
			selectAll: filtersChanged ? false : this.state.selectAll
		});

		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
		}

		const fetchData = () => {
			this.filterTimeout = null;
			this.getData(tableState.page, tableState.pageSize, filtered, sorted);
		};
		if (filtersChanged) {
			this.filterTimeout = setTimeout(fetchData, PROCEDURE_FILTER_DEBOUNCE_MS);
		} else {
			fetchData();
		}
	};

	uploadToS3 = async (data) => {

		let fileName = this.state.currentUser.payload.sub+"_Report.pdf";

		this.setState({ fileName });

		//WORKING!!!!
		//let response1 = await fetch(warrantyPDF);
		//let blob = await response1.blob(); // download as Blob object

		const blob = await pdf(<MyDocument data={data} />).toBlob();

    try {

      var url = "https://udala92lwh.execute-api.us-west-2.amazonaws.com/v1/g2-reports/"+fileName;

  		const options = {
  			method: 'PUT',
  			headers: {
  				Authorization: this.state.currentUser.jwtToken
  			},
  			body: blob
  		};

      const response = await fetch(url, options);

  		const body = await response.json();
  		console.log("upload response: " + JSON.stringify(body));

  		if (body.status == 'Success') {
  			console.log("Upload Success!");
  		} else {
  			//ADD ERROR MESSAGE
  		}

    }
    catch (err) {
      console.log(err);
    }

	}

	getData = async (page = 0, pageSize = 15, filtered = [], sorted = []) => {
		const requestId = ++this.procedureRequestId;
		const activeFilters = getActiveProcedureFilters(filtered);
		const timezone = Moment.tz.guess();
		const endpoint = this.state.currentDataSetting == 0
			? "get-all-preformed-procedures"
			: "get-all-preformed-procedures-for-date-range";
		const queryParams = [
			["Paginated", "true"],
			["CurrentPage", page + 1],
			["PageSize", pageSize],
			["Timezone", timezone],
			["Filters", JSON.stringify(activeFilters)]
		];

		if (this.state.currentDataSetting != 0) {
			queryParams.push(["StartDate", this.state.startDate]);
			queryParams.push(["EndDate", this.state.endDate]);
		}

		if (sorted && sorted.length > 0) {
			queryParams.push(["SortBy", sorted[0].id]);
			queryParams.push(["SortDirection", sorted[0].desc ? "desc" : "asc"]);
		}

		const queryString = queryParams
			.map(param => encodeURIComponent(param[0]) + "=" + encodeURIComponent(param[1]))
			.join("&");
		const url = appendProductFilter(
			"https://9xnwyna9id.execute-api.us-west-2.amazonaws.com" + process.env.REACT_APP_ENV + endpoint + "?" + queryString,
			this.state.productType
		);
		this.setState({ loading: true, procedureErrorMessage: "" });

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				}
			});

			if (requestId !== this.procedureRequestId) {
				return;
			}

			if (!response.ok) {
				throw new Error(response.status + " " + response.statusText);
			}

			const body = await response.json();
			if (body.status != 'Success') {
				throw new Error(body.error || "Unable to load procedures.");
			}

			const results = Array.isArray(body.results) ? body.results : Array.isArray(body.response) ? body.response : [];
			const selectAll = results.length > 0 && results.every((procedure, index) => {
				return !!this.state.selectedProcedureRows[this.getProcedureRowId(procedure, index)];
			});
			const nextState = {
				procedures: results,
				selectdata: results,
				pages: Number(body.pages) || 0,
				totalProcedures: Number(body.totalrecords) || 0,
				selectAll,
				loading: false
			};

			if (this.state.currentDataSetting == 0 && activeFilters.length == 0) {
				if (body.earliestTimestamp) {
					nextState.startDate = Moment(body.earliestTimestamp).format('YYYY-MM-DD');
				}
				if (body.latestTimestamp) {
					nextState.endDate = Moment(body.latestTimestamp).format('YYYY-MM-DD');
				}
			}

			this.setState(nextState);
		}
		catch (err) {
			if (requestId !== this.procedureRequestId) {
				return;
			}
			console.log("Paginated procedure reports error: " + err);
			this.setState({
				procedures: [],
				selectdata: [],
				pages: 0,
				totalProcedures: 0,
				selectAll: false,
				loading: false,
				procedureErrorMessage: "Unable to load procedures."
			});
		}
	};

  getProcedureTypes = async () => {

		const requestId = ++this.procedureTypesRequestId;
		var url = appendProductFilter(
			"https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"all-procedures",
			this.state.productType
		);
		this.setState({ procedureErrorMessage: "" });

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});
		const body = await response.json();
		if (requestId !== this.procedureTypesRequestId) {
			return;
		}
		console.log("allprocedure Types: " + JSON.stringify(body));

		if (body.status == 'Success') {
			if (body.results.length > 0) {
        this.setState({ procedureTypes: body.results}, () => {
					console.log("procedureTypes: " + JSON.stringify(this.state.procedureTypes));
				});
			} else {
				//this.noResults = true;
			}
		}
	};

	sendMessage = (event) => {
		event.preventDefault();

		console.log("Send message");
		let email = event.target.email.value;
    console.log(`email is:`, email);

		this.sendEmailMessage(email);
	}

	sendEmailMessage = async (emailAddress) => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"email-pdf-to-user?EmailRecipient="+emailAddress+"&FileName="+this.state.fileName;

		console.log("Send Email URL: " + url);

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("Send Email response: " + JSON.stringify(body));

		if (body.status == 'Success') {

			this.toggle();
			this.setState({
				statusSubject: "SUCCESS!",
				statusMessage: "Email sent Successfully!"
			})

		} else {

			this.toggle();
			this.setState({
				statusSubject: "FAILED!",
				statusMessage: "Failed to send Email to "+emailAddress+"."
			})

		}

		this.toggle3();

	};

  filterCaseInsensitive(filter, row) {
		const id = filter.pivotId || filter.id;

		//console.log("filterCaseInsensitive row[id]: " + JSON.stringify(id));

		if (id == 'date') {
			var dateString = Moment(row[id]).format('MMM Do YYYY');
			return (
					dateString !== undefined ?
							String(dateString.toString().toLowerCase()).includes(filter.value.toLowerCase())
					:
							true
			);
		}

		if (row[id] !== null){
			return (
					row[id] !== undefined ?
							String(row[id].toString().toLowerCase()).includes(filter.value.toLowerCase())
					:
							true
			);
		}
	}

  getTrProps (state, rowInfo, instance) {

    if (rowInfo) {
      //console.log('getTrProps rowInfo: ' + JSON.stringify(rowInfo.row.totalSeconds));

      if (rowInfo.row.procedureType != "7mm" && rowInfo.row.procedureType != "3mm" && rowInfo.row.procedureType != "25mm") {
        if (rowInfo.row.totalSeconds<11) {
          return {
              style: {
                color: "#FC9E2D"
              }
          }
        }
      }

    }
    return {};
  };

	render() {
		const pdfdata = this.state.procedures.map((procedure, key) => this.formatProcedure(procedure, key, true));
		const selectedProcedures = Object.keys(this.state.selectedProcedureRows).map(rowId => this.state.selectedProcedureRows[rowId]);

		const data = this.state.procedures.map((procedure, key) => {
			const formattedProcedure = this.formatProcedure(procedure, key, false);
			return Object.assign({}, formattedProcedure, {
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						{/* use this button to add a edit kind of action */}
						<Button
							onClick={() => {
								let obj = pdfdata.find(o => o.id === formattedProcedure.id);
								this.setState({
									modal2: !this.state.modal2,
									obj: obj,
                  objArray: obj
								});
							}}
							color="inverse"
							size="sm"
							round="true"
							icon="true"
							title="Send Message"
						>
							Generate Procedure Report
						</Button>
						{/* use this button to remove the data row */}
						{/* <Button
							onClick={() => {
								let newdata = data2;
								newdata.find((o, i) => {
									if (o.id === key) {
										newdata.splice(i, 1);
										console.log(newdata);
										return true;
									}
									return false;
								});
								this.setState({ jsonData: newdata });
							}}
							className="ml-1"
							color="danger"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-times" />
						</Button> */}
					</div>
				)
				});
			});

		return (
      <Card className="card-hover">
				<CardBody>
          <Row>
            <Col xs="12" md="5" lg="5" className="text-left">
              <h1 style={{color:'#737782'}}>Procedure Reports</h1>
            </Col>
            <Col xs="12" md="7" lg="7" className="text-left">
              <span style={{color:'#737782', fontSize: "18px"}}><b>Non Surgical</b> and <b>Surgical</b> procedures show in <b style={{ color: "#FC9E2D"}}>orange</b> are considered to be too short (less than 10 seconds) and will not be counted as a procedure due to the short time. <b>Pain Relief</b> procedures that are less than 10 seconds will be counted as a procedure.</span>
            </Col>
          </Row>
          <Row className="mt-3 mb-3">
            <Col xs="12" md="6" lg="6" className="text-left">
              <div className="d-flex justify-content-between float-left" style={{ width: '400px' }}>
                <div className="mt-1" style={{ width: '45px' }}>
                  <h6 style={{ lineHeight: '1.8' }}>From:</h6>
                </div>
                <div className="mt-1 ml-2" style={{ width: '135px' }}>
                  <Input name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleDateChange} />
                </div>
                <div className="mt-1 ml-2" style={{ width: '23px' }}>
                  <h6 style={{ lineHeight: '1.8' }}>To:</h6>
                </div>
                <div className="mt-1 ml-2" style={{ width: '135px' }}>
                  <Input name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleDateChange} />
                </div>
                <div className="mt-1 ml-2" style={{ width: '50px' }}>
                  <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="GO">
                    GO
                  </Button>
                </div>
              </div>
            </Col>
            <Col xs="12" md="6" lg="6" className="text-right">
              <div>
				<Button
					className="mr-2"
					color="dark"
					disabled={this.state.loading}
					onClick={this.handleRefresh}
					title="Refresh current page"
					aria-label="Refresh current page"
				>
					<i className={"fa fa-sync" + (this.state.loading ? " fa-spin" : "")} />
					<span className="ml-1">Refresh</span>
				</Button>
                <ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
                  <DropdownToggle color="dark" caret>
                    {this.state.currentItem}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
										<DropdownItem onClick={() => this.selectDropDownItem(1, 'Today')}>Today</DropdownItem>
                    <DropdownItem onClick={() => this.selectDropDownItem(2, 'This Week')}>This Week</DropdownItem>
                    <DropdownItem onClick={() => this.selectDropDownItem(3, 'This Month')}>This Month</DropdownItem>
                    <DropdownItem onClick={() => this.selectDropDownItem(5, 'Last 30 Days')}>Last 30 Days</DropdownItem>
                    <DropdownItem onClick={() => this.selectDropDownItem(4, 'Custom Range')}>Custom Range</DropdownItem>
                  </DropdownMenu>
                </ButtonDropdown>
								{selectedProcedures.length>0 &&
									<Button className="ml-3" size="md" color="brightgreen" title="PRINT REPORT" onClick={() => this.generateReport(selectedProcedures)}>
	                  Generate Report
	                </Button>
								}
              </div>
            </Col>
          </Row>
					{this.state.procedureErrorMessage &&
						<Row className="mb-3">
							<Col xs="12">
								<div className="text-center" style={{ color: '#ffc10e' }}>
									{this.state.procedureErrorMessage}
								</div>
							</Col>
						</Row>
					}
			<ReactTable
            style={{backgroundColor:'#000', padding:'10px'}}
						columns={[
							{
								Header: (
									<Fragment>
									<Label for="confirmed" check>
                  <Input
                    type="checkbox"
                    onChange={this.handleChange}
                    checked={this.state.selectAll}
                  />
										{this.state.selectAll ? "Unselect All" : "Select All"}
									</Label>
									</Fragment>
                ),
                Cell: row => (
									<div style={{ textAlign: "center", position: 'relative' }}>
                  <Input
                    type="checkbox"
                    checked={!!this.state.selectedProcedureRows[row.original.id]}
                    onChange={() => this.handleSingleCheckboxChange(row.index)}
                  />
									</div>
                ),
                minWidth: 120,
								maxWidth: 150,
                sortable: false,
                filterable: false
							},
							{
								Header: "Date of Procedure",
								accessor: "date",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{Moment(row.value).format("MMM Do YYYY")}</div>
                  )
							},
							{
								Header: "Procedure Type",
								accessor: "procedureType",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
							{
								Header: "Power",
								accessor: "power",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
							{
								Header: "Wavelength",
								accessor: "wavelength",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
              {
								Header: "Treatments",
								accessor: "treatments",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
              {
								Header: "Dosage",
								accessor: "dosage",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
							{
								Header: "Procedure Length",
								accessor: "length",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
              {
								Header: "",
								accessor: "totalSeconds",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								show: false,
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
							{
								Header: "Serial Number",
								accessor: "serialNumber",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							},
							{
								Header: "Local Time",
								accessor: "time",
								style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
								Cell: row => (
                    <div style={{ textAlign: "center" }}>{row.value}</div>
                  )
							}
						]}
						defaultPageSize={15}
            sortable={true}
						showPaginationBottom={true}
						className="-striped -highlight"
						data={data}
						pages={this.state.pages}
						loading={this.state.loading}
						loadingText="Loading procedures..."
						LoadingComponent={ProceduresLoading}
						NoDataComponent={ProceduresNoData}
						getNoDataProps={() => ({ loading: this.state.loading })}
						PaginationComponent={ProceduresPagination}
						manual
						onFetchData={this.handleFetchData}
						ref={table => { this.table = table; }}
            getTrProps={this.getTrProps}
						filterable
            defaultFilterMethod={(filter, row) => this.filterCaseInsensitive(filter, row) }
					/>
        </CardBody>
        <div>
          <Modal isOpen={this.state.modal} toggle={this.toggle}>
    				<ModalHeader toggle={this.toggle}>Procedure Report</ModalHeader>
						<Form onSubmit={this.sendMessage}>
    				<ModalBody>
							<Row>
								<Col xs="12" md="12" lg="12" className="text-left pb-3">
									<h4>Send message to owner of Device: {this.state.obj.SerialNumber}</h4>
								</Col>
							</Row>
								<FormGroup>
									<Label for="subject">Send message to owner of Device:</Label>
									<Input type="text" name="email" id="email" defaultValue={this.state.currentUser.payload.email}/>
								</FormGroup>
              <PDFViewer style={{ height: "600px", width: "100%"}}>
                <MyDocument data={selectedProcedures} />
              </PDFViewer>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle}>Cancel</Button>
							<Button color="primary" type="submit">Send</Button>
  					</ModalFooter>
						</Form>
  			  </Modal>
				</div>
        <div>
          <Modal isOpen={this.state.modal2} toggle={this.toggle2}>
    				<ModalHeader toggle={this.toggle2}>Procedure Report</ModalHeader>
    				<ModalBody>
              <PDFViewer style={{ height: "730px", width: "100%"}}>
                <MyDocument data={[this.state.objArray]} />
              </PDFViewer>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle2}>OK</Button>
  					</ModalFooter>
  			  </Modal>
				</div>
				<div>
					<Modal isOpen={this.state.modal3} toggle={this.toggle3}>
						<ModalHeader toggle={this.toggle3}>{this.state.statusSubject}</ModalHeader>
						<ModalBody>
							<span>{this.state.statusMessage}</span>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" className="ml-1" onClick={this.toggle3}>OK</Button>
						</ModalFooter>
					</Modal>
				</div>
				<div>
					<Modal isOpen={this.state.modal4} toggle={this.toggle4}>
						<ModalHeader toggle={this.toggle4}>Report Generation Error</ModalHeader>
						<ModalBody>
							<span>Maximum 200 procedures for Procedure Report.</span>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" className="ml-1" onClick={this.toggle4}>OK</Button>
						</ModalFooter>
					</Modal>
				</div>
      </Card>
		);
	}
}

export default ProceduresList;
